import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Button, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import { EMAIL_SUPPORT } from 'src/modules/emails';

import EmptyStateTemplate from 'src/components/EmptyState/EmptyStateTemplate';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.components.empty-state.title',
    description: 'career-platform.components.empty-state.description',
    button: 'career-platform.components.empty-state.button',
};

const handleClick = () => window.location.reload();

const EmptyState: TranslatedComponent = ({ trls }) => {
    const { isMobile } = useBreakpoint();
    return (
        <EmptyStateTemplate
            title={trls[TrlKeys.title]}
            description={
                <>
                    {trls[TrlKeys.description]}{' '}
                    <a className={styles.link} href={`mailto:${EMAIL_SUPPORT}`}>
                        {EMAIL_SUPPORT}
                    </a>
                </>
            }
        >
            <VSpacing default={24} gteS={40} />
            <Button mode="primary" onClick={handleClick} stretched={isMobile}>
                {trls[TrlKeys.button]}
            </Button>
        </EmptyStateTemplate>
    );
};

export default translation(EmptyState);
